import React, { useEffect, useState } from "react";
import signinImg from "../../assets/images/signin-logo.png";
import { Link, useNavigate, NavLink } from "react-router-dom";
import { useFormik } from "formik";
import { object, string } from "yup";
import axios from "axios";
import { FaEye, FaEyeSlash } from "react-icons/fa";

let loginSchema = object({
  username: string()
    .required("Username is required")
    .matches(
      /^[a-zA-Z0-9@._-]{3,50}$/,
      "Enter a valid username (3–50 characters, letters, numbers, @ . _ - allowed)",
    ),
  password: string().required("Password is required"),
});
export function SignIn() {
  const [isLoading, setIsLoading] = useState(false);
  const [serverError, setServerError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
    },
    validationSchema: loginSchema,
    validateOnBlur: true,
    onSubmit: async (values) => {
      setIsLoading(true);
      setServerError("");

      const payload = {
        username: values.username.trim(),
        password: values.password.trim(),
      };

      console.log("👉 Payload before sending to API:", payload);

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/admin/login/`,
          payload,
        );
        console.log("✅ Response from API:", response);

        if (response.data.status === "success") {
          const token = response.data.data.token;
          const userData = response.data.data;
          localStorage.setItem("token", token);
          localStorage.setItem("userData", JSON.stringify(userData));
          navigate("/dashboard");
        } else {
          setServerError(response.data.message || "Login failed");
        }
      } catch (error) {
        setServerError(
          error.response?.data?.message ||
            "Something went wrong. Please try again.",
        );
      } finally {
        setIsLoading(false);
      }
    },
  });

  return (
    <div className="signin-container">
      <div className="signin-left">
        <div>
          <div className="signin-logo">
            <img src={signinImg} />
          </div>
          <div className="signin-lefttext">
            Welcome to the Go Mak Admin Dashboard — your all-in-one platform for
            managing and optimizing medicine delivery operations. From tracking
            orders and monitoring delivery partners to ensuring security,
            reliability, and on-time service, this dashboard empowers you to
            streamline processes and provide healthcare providers with the
            medicines they need, when they need them.
          </div>
        </div>
        {/* <div className="download-app">
          <h5>Need the Desktop Application?</h5>
          <p>Download the official Go Mak Wholesaler desktop app.</p>

          <Link to="/download-desktop-app">
            <button className="download-btn">Download Desktop App </button>
          </Link>
        </div> */}
      </div>
      <div className="signin-right">
        <div>
          <form className="signin-formContainer" onSubmit={formik.handleSubmit}>
            <div className="signin-title">Sign In</div>
            <div className="signin-subtitle">Welcome to Go Mak Admin</div>
            <div className="signin-field">
              <label>
                <span className="text-danger">*</span> User Name
              </label>
              <div>
                <input
                  type="text"
                  placeholder="Enter username"
                  maxLength={50}
                  name="username"
                  value={formik.values.username}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={
                    formik.touched.username && formik.errors.username
                      ? "input-error-signIn"
                      : ""
                  }
                />
                {formik.touched.username && formik.errors.username && (
                  <div className="error-message-signIn">
                    {formik.errors.username}
                  </div>
                )}
              </div>
            </div>
            <div className="signin-field">
              <label>
                <span className="text-danger">*</span>Password
              </label>
              {/* <div>
                <input
                  type="password"
                  placeholder="Enter Password"
                  name="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={
                    formik.touched.password && formik.errors.password
                      ? "input-error-signIn"
                      : ""
                  }
                />
                {formik.touched.password && formik.errors.password && (
                  <div className="error-message-signIn">
                    {formik.errors.password}
                  </div>
                )}
              </div> */}
              <div className="password-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter password"
                  name="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={
                    formik.touched.password && formik.errors.password
                      ? "input-error-signIn"
                      : ""
                  }
                />
                <span
                  className="eye-icon"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
              {formik.touched.new_password && formik.errors.new_password && (
                <div className="error-message-signIn">
                  {formik.errors.new_password}
                </div>
              )}
              {serverError && (
                <div
                  className="error-message-signIn"
                  style={{ marginBottom: "10px" }}
                >
                  {serverError}
                </div>
              )}
            </div>
            <div className="btnLogin">
              <button type="submit" disabled={isLoading}>
                {isLoading ? "Logging in..." : "Login"}
              </button>
            </div>
            <div className="forgot-text">
              <Link
                to="/forgot"
                style={{ color: "#FF961F", textDecoration: "none" }}
              >
                Forgot Password
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
